import { render, staticRenderFns } from "./WizardSuccess.vue?vue&type=template&id=6a174578&"
import script from "./WizardSuccess.vue?vue&type=script&lang=js&"
export * from "./WizardSuccess.vue?vue&type=script&lang=js&"
import style0 from "./WizardSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports